import React, { useEffect } from "react";
import "../assets/css/Chat.css";
import { IoIosChatbubbles } from "react-icons/io";
import { FaPhone } from "react-icons/fa6";
import { IoMail } from "react-icons/io5";
import { SubmitHandler, useForm } from 'react-hook-form';
import { TranslationKey, useTranslate } from "../services/translation";
import { useLanguage } from "../LanguageContext";

export interface ChatData{
    telephone: string;
    email: string;
    content: string;
    lang?: string;
}

interface propsType{
    submit: SubmitHandler<ChatData>;
}

const Chat = ({submit} : propsType) =>{

    const { translate } = useTranslate();
    const {language} = useLanguage()

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
      } = useForm<ChatData>();

      const validateEmail = (value: any) => {
        if(!value) return "common.email_required"
        if (!value.includes('@')) {
            return "common.invalid_email";
        }
        return true;
    };

    useEffect(()=>{
        setValue("lang", language);
    }, [language, setValue])
    
    return (
        <div className="chat fixed">
            <div className="c-header gradient-bg width-100p">
                <span className="white left-10"><IoIosChatbubbles size={25} /></span>
                <span className="white left-10">{translate('common.tell_me_how_can_i_assist_yout')}</span>
            </div>
            <form className="c-content gradient-border" onSubmit={handleSubmit(submit)}>
                <div className="c-input gradient-bg radius-7">
                    <span><FaPhone /></span>
                    <input type="text" placeholder={translate('common.your_telephone')} {...register('telephone', {required: true, maxLength: 20})} 
                    onKeyPress={(e) => {
                        const pattern = /[0-9+ ]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)) {
                            e.preventDefault();
                        }
                    }}
                    />
                </div>
                {errors.telephone && <p className="error">{translate("common.telephone_required")}</p>}
                <div className="c-input gradient-bg radius-7">
                    <span><IoMail /></span>
                    <input type="mail" placeholder={translate("common.your_email_address")} {...register('email', {validate: validateEmail})}/>
                </div>
                {errors.email && <p className="error">{translate(errors.email.message as TranslationKey)}</p>}
                <div className="c-msg gradient-bg radius-7">
                    <textarea placeholder={translate("common.your_message") + '...'} {...register('content', {required: true})}></textarea>
                </div>
                {errors.content && <p className="error">{translate('common.message_required')}</p>}
                <button className="gradient-bg c-btn" type="submit">{translate('common.send')}</button>
            </form>
        </div>
    )
}

export default Chat;